// Markdown from meta repo files is untrusted: it is rendered with marked, then every byte of HTML
// passes DOMPurify before it reaches the DOM (scripts, event handlers, javascript: URLs, iframes,
// forms and inline styles are removed). Nothing else in the app sets innerHTML.
import DOMPurify from 'dompurify';
import { marked } from 'marked';

let hooked = false;

function hook(): void {
  if (hooked) return;
  hooked = true;
  // Links in repo files open GitHub or elsewhere: a new tab, with no opener and no referrer.
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A' && node.getAttribute('href')) {
      node.setAttribute('target', '_blank');
      node.setAttribute('rel', 'noopener noreferrer');
    }
  });
}

export function sanitize(html: string): string {
  hook();
  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    FORBID_TAGS: ['style', 'form', 'input', 'button', 'textarea', 'select', 'iframe', 'object', 'embed'],
    FORBID_ATTR: ['style'],
  });
}

export function renderMarkdown(markdown: string): string {
  const html = marked.parse(markdown, { async: false, gfm: true, breaks: false });
  return sanitize(html);
}
